// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --lc-accent-color: #6a72fb;
  /* For use with transparency. */
  --lc-accent-color-rgb: 84, 92, 251;

  --lc-header-height: 56px;

  --lc-content-width: 700px;
  --lc-line-height: 1.4;
  --lc-margin-big: 50px;
  --lc-margin-medium: 25px;
  --lc-margin-small: 10px;
}

.language-coach {
  --accent-color: var(--lc-accent-color);
  --accent-color-rgb: var(--lc-accent-color-rgb);
  --outline-active: 2px solid #282ea6;
  --outline-focus: 2px solid #282ea6aa;

  /**
   * The sticky header needs to be moved up a bit to not be over the title text.
   * This only applies to the reading material page.
   */
  --lc-sticky-header-adjust: 16px;


  height: 100%;
  width: 100%;
  position: relative;

  .splitterSplit {
    height: calc(100% - var(--lc-header-height));
  }

  * {
    scroll-margin-top: var(--header-height);
  }
  .lcReadingSelectedSentence {
    scroll-margin-top: calc(var(--header-height) * 2);
  }
}

a.lcButton,
.lcButton {
  text-decoration: none;
  padding: 0.7em 1.7em;
  border-radius: 3em;
  border: none;
  background-color: var(--lc-accent-color);
  color: #fff;
  cursor: pointer;
  transition: background 0.1s;
  box-shadow: 0 0.3em 0.6em #0003;
}

.lcButton:hover:not(:disabled) {
  background-color: #545cfb;
}

.lcButton:active:not(:disabled) {
  outline: var(--outline-active);
}

.lcButton:focus {
  outline: var(--outline-focus);
}


.lcButton:hover {
  opacity: 1;
}

.lcButton:disabled {
  cursor: default;
  opacity: 0.6;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/LanguageCoach/index.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,kCAAkC;;EAElC,wBAAwB;;EAExB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;EAC9C,mCAAmC;EACnC,oCAAoC;;EAEpC;;;IAGE;EACF,+BAA+B;;;EAG/B,YAAY;EACZ,WAAW;EACX,kBAAkB;;EAElB;IACE,4CAA4C;EAC9C;;EAEA;IACE,uCAAuC;EACzC;EACA;IACE,iDAAiD;EACnD;AACF;;AAEA;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;AACd","sourcesContent":[":root {\n  --lc-accent-color: #6a72fb;\n  /* For use with transparency. */\n  --lc-accent-color-rgb: 84, 92, 251;\n\n  --lc-header-height: 56px;\n\n  --lc-content-width: 700px;\n  --lc-line-height: 1.4;\n  --lc-margin-big: 50px;\n  --lc-margin-medium: 25px;\n  --lc-margin-small: 10px;\n}\n\n.language-coach {\n  --accent-color: var(--lc-accent-color);\n  --accent-color-rgb: var(--lc-accent-color-rgb);\n  --outline-active: 2px solid #282ea6;\n  --outline-focus: 2px solid #282ea6aa;\n\n  /**\n   * The sticky header needs to be moved up a bit to not be over the title text.\n   * This only applies to the reading material page.\n   */\n  --lc-sticky-header-adjust: 16px;\n\n\n  height: 100%;\n  width: 100%;\n  position: relative;\n\n  .splitterSplit {\n    height: calc(100% - var(--lc-header-height));\n  }\n\n  * {\n    scroll-margin-top: var(--header-height);\n  }\n  .lcReadingSelectedSentence {\n    scroll-margin-top: calc(var(--header-height) * 2);\n  }\n}\n\na.lcButton,\n.lcButton {\n  text-decoration: none;\n  padding: 0.7em 1.7em;\n  border-radius: 3em;\n  border: none;\n  background-color: var(--lc-accent-color);\n  color: #fff;\n  cursor: pointer;\n  transition: background 0.1s;\n  box-shadow: 0 0.3em 0.6em #0003;\n}\n\n.lcButton:hover:not(:disabled) {\n  background-color: #545cfb;\n}\n\n.lcButton:active:not(:disabled) {\n  outline: var(--outline-active);\n}\n\n.lcButton:focus {\n  outline: var(--outline-focus);\n}\n\n\n.lcButton:hover {\n  opacity: 1;\n}\n\n.lcButton:disabled {\n  cursor: default;\n  opacity: 0.6;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
